// http://react-component.github.io/badgeboard/
// http://react-component.github.io/slider/

import React from 'react';
import Slider from 'rc-slider';
// We can just import Slider or Range to reduce bundle size
// import Slider from 'rc-slider/lib/Slider';
// import Range from 'rc-slider/lib/Range';
import * as PropTypes from "prop-types";
import 'rc-slider/assets/index.css';
import '../../../assets/sass/components/slider.scss';

class SliderNormal extends React.Component {

    static propTypes = {
        // set name for component
        name: PropTypes.string,
        // event change
        onSliderChange: PropTypes.func,
    };

    static defaultProps = {
        showMarks: false
    }

    state = {
        value: 0,
    }

    onSliderChange = (value) => {
        this.setState({
            value,
        });

        if (this.props.onSliderChange)
            this.props.onSliderChange(this.props.name, value);
    }

    reset = () => {
        this.setState({ value: null });
    }

    render() {
        return (
            <div className="slider slider-normal">
                <div className="slider-wrapper">
                    <Slider
                        {...this.props}
                        value={this.state.value}
                        onChange={this.onSliderChange}

                    />
                    {this.props.showMarks &&
                        <div className="marks-wrapper">
                            <small className="mark-min">{this.props.min || 0}</small>
                            <small className="mark-max">{this.props.max || 100}</small>
                        </div>}
                </div>
                <span>{this.state.value >= 10 ? this.state.value : `0${this.state.value}`}</span>
            </div>
        );
    }
}

export default SliderNormal;
